module.exports = __webpack_public_path__ + "img/travelService-new-title.64670133.png";